export default __webpack_public_path__ + "static/media/loading_blue_128x.e9318cfd.gif";